import { withStyles } from '@material-ui/core/styles';
import Checkbox from './Checkbox';
import styles from './Checkbox.styles';

export default withStyles(styles)(Checkbox);
